export default __webpack_public_path__ + "static/media/NavICclock.866838e5.pdf";